import axios from 'axios';

const api = axios.create({
  baseURL: 'https://ksgc-server.kintelligence.com.br:3360'
  //baseURL: 'http://localhost:3061'
});

export default api;